import React from 'react';
import { AnalyticsContext } from './AnalyticsProvider';

export default function useAnalytics() {
  return React.useContext(AnalyticsContext);
}
